module.exports = __webpack_public_path__ + "static/media/jabar.248fa5fc.png";